export enum LibraryItemType
{
    None = 0,
    Folder,
    SermonSeries,
    PremiumSermon,
    PremiumSermonSeries,
    BuilderAsset,
    LinkAsset,
    FileAsset
}

export function printLibraryItemType(type: LibraryItemType) {
    switch (type) {    
        case LibraryItemType.Folder:
            return "Folder";
        case LibraryItemType.SermonSeries:
            return "Series";
        case LibraryItemType.PremiumSermon:
            return "Premium Sermon";
        case LibraryItemType.PremiumSermonSeries:
            return "Premium Series";
        default:
            return ''
    }
}